// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest {
    'start'?: number;
    'pageSize'?: number;
    'memberNumbers': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest>> = [
        {
            "name":     "start",
            "baseName": "start",
            "type":     "number"
        },
        {
            "name":     "pageSize",
            "baseName": "pageSize",
            "type":     "number"
        },
        {
            "name":     "memberNumbers",
            "baseName": "memberNumbers",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimClaimV1ClaimAccumulatorSearchAccumulatorSearchRequest.attributeTypeMap;
    }
}
